import {Pointer} from '../queries/types/parse';

export const equalToQuery = (field: string, value: string | Pointer) => ({
  [field]: {equalTo: value},
});
